var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5254 7.24999L12.7504 3.475C11.9587 2.68333 10.8671 2.25833 9.75039 2.31666L5.58372 2.51666C3.91705 2.59166 2.59205 3.91666 2.50872 5.57499L2.30872 9.74166C2.25872 10.8583 2.67539 11.95 3.46705 12.7417L7.24205 16.5167C8.79205 18.0667 11.3087 18.0667 12.8671 16.5167L16.5254 12.8583C18.0837 11.3167 18.0837 8.79999 16.5254 7.24999ZM7.91705 10.3167C6.59205 10.3167 5.51705 9.24166 5.51705 7.91666C5.51705 6.59166 6.59205 5.51666 7.91705 5.51666C9.24205 5.51666 10.3171 6.59166 10.3171 7.91666C10.3171 9.24166 9.24205 10.3167 7.91705 10.3167Z",
    fill: "#CD6422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.37792e2fd409a04e5042822a3276f258.svg";
export { ForwardRef as ReactComponent };